import { render, staticRenderFns } from "./PasswordResetRequestForm.vue?vue&type=template&id=54ac3918"
import script from "./PasswordResetRequestForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports